import { render } from "./Page2.vue?vue&type=template&id=745abdfd"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=745abdfd&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__